The underlying library question that the component is based on.

The availability of this field is dependent on `sourceCode`:

- `Custom` is always null.
- `Library` is always non-null.
